import { render, staticRenderFns } from "./riskReport.vue?vue&type=template&id=2c485c69&scoped=true&"
import script from "./riskReport.vue?vue&type=script&lang=js&"
export * from "./riskReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c485c69",
  null
  
)

export default component.exports